export default __webpack_public_path__ + "static/BC Certified logo_ISO 27001-2022 RVA_ENG-87c01e658fccc33d0e03595229134456.png";